import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
export const TagListSearchParamsSchema = z.object({
    name: z.string().optional(),
    dateRange: z.string().optional(),
    version: z.string().optional(),
    searchSwitcher: z.enum([
        'name',
        'version'
    ]).optional().default('version'),
    condition: z.string().optional(),
    sortOrder: z.enum([
        'asc',
        'desc'
    ]).optional().default('desc')
});
export const Route = createFileRoute('/org/$organization/$project/$application/devops/tags')({
    validateSearch: TagListSearchParamsSchema,
    loaderDeps: (param)=>{
        let { search } = param;
        return {
            search
        };
    },
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
